import { CalendarClock, Car, User } from 'lucide-react';
import type { CandidateLesson } from '../types';
import { durationLabel, slotLabel } from '../lib/format';
import { Button } from './charte';
import { Sheet } from './shell/Sheet';

/**
 * « Nouvelle leçon programmée » (J25) : la ou les leçons que l'auto-école vient de planifier, avec « OK » seulement
 * (ni accepter ni refuser), sans croix. Échap ou un clic à côté valent « OK ».
 */
export function NewLessonsSheet({ lessons, onOk }: { lessons: CandidateLesson[]; onOk: () => void }) {
  const several = lessons.length > 1;
  return (
    <Sheet
      title={several ? 'Nouvelles leçons programmées' : 'Nouvelle leçon programmée'}
      description={several ? 'Votre auto-école a planifié ces leçons pour vous.' : 'Votre auto-école a planifié cette leçon pour vous.'}
      onClose={onOk}
      closeButton={false}
      footer={
        <Button variant="primary" className="flex-1" onClick={onOk}>
          OK
        </Button>
      }
    >
      <ul className="grid gap-3">
        {lessons.map((lesson) => (
          <li key={lesson.id} className="grid gap-2.5 rounded-row bg-surface-light p-4">
            {[
              { icon: CalendarClock, text: <span className="font-semibold text-heading">{slotLabel(lesson.startsAt, lesson.endsAt)}</span> },
              {
                icon: User,
                text: (
                  <>
                    Moniteur : <span className="font-semibold text-heading">{lesson.instructorName ?? 'À confirmer'}</span>
                  </>
                ),
              },
              { icon: Car, text: <>{[lesson.lessonType, durationLabel(lesson.startsAt, lesson.endsAt)].filter(Boolean).join(' · ')}</> },
            ].map(({ icon: Icon, text }, i) => (
              <p key={i} className="flex items-center gap-3 text-sm text-body">
                <span className="grid h-8 w-8 shrink-0 place-items-center rounded-xl bg-white text-primary shadow-navbar">
                  <Icon size={16} aria-hidden />
                </span>
                <span>{text}</span>
              </p>
            ))}
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
